import request from '@/utils/request'

export function getList(data) {
    return request({
        url: '/backend/article/getList',
        method: 'post',
        data: data
    })
}
export function createUpdate(data) {
    return request({
        url: '/backend/article/createUpdate',
        method: 'post',
        data: data
    })
}
export function getDetail(data) {
    return request({
        url: '/backend/article/getDetail',
        method: 'post',
        data: data
    })
}
export function del(data) {
    return request({
        url: '/backend/article/delete',
        method: 'post',
        data: data
    })
}
export function updateStatus(data) {
    return request({
        url: '/backend/article/updateStatus',
        method: 'post',
        data: data
    })
}
export function updateRecommend(data) {
    return request({
        url: '/backend/article/updateRecommend',
        method: 'post',
        data: data
    })
}
export function updateSort(data) {
    return request({
        url: '/backend/article/updateSort',
        method: 'post',
        data: data
    })
}
export function importArticle(data) {
    return request({
        url: '/backend/article/importArticle',
        method: 'post',
        data: data
    })
}